import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const ShouldUseNewLayout = (pathname: string): boolean =>
  pathname.startsWith('/forms/maintenanceAmendmentOfTermsApplication') ||
  pathname.startsWith('/forms/maintenancePriorityDeviation') ||
  pathname.startsWith('/forms/releaseOfCollaterals') ||
  pathname.startsWith('/forms/deMinimisAid') ||
  pathname.startsWith('/forms/finalReportGrantSimple') ||
  pathname.startsWith('/forms/payoutRequestGrantSimple');

export type LayoutType = 'main' | 'form';

type LayoutContextType = {
  layout: LayoutType;
  setLayout: (layout: LayoutType) => void;
};

export const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider = ({ defaultLayout, children }: { defaultLayout: LayoutType; children: ReactNode }) => {
  const location = useLocation();
  const [layout, setLayout] = useState<LayoutType>(defaultLayout);

  useEffect(() => {
    if (location.pathname && ShouldUseNewLayout(location.pathname)) {
      setLayout('form');
    } else {
      setLayout(defaultLayout);
    }
  }, [location.pathname, defaultLayout]);

  return <LayoutContext.Provider value={{ layout, setLayout }}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
